import * as Sentry from '@sentry/react';
if (window.sentryEnvironment) {
  Sentry.init({
    dsn: 'https://ff94ed3a7d9149d3b85db4470ae506e1@o326813.ingest.sentry.io/1835583',
    environment: window.sentryEnvironment,
    integrations: [Sentry.reactRouterV5BrowserTracingIntegration({
      history
    }),
    // See: https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['anchor-frontend-sentry-key'],
      behaviour: 'drop-error-if-contains-third-party-frames'
    })],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/(my|demo).anchor.sh/],
    release: GIT_SHA1,
    denyUrls: [/^chrome-extension:\/\//i, /^safari-extension:\/\//i, /clarity\.js/i, /adsscriptloaderstatic/i, /\/\/hidden\//i, /\/appcues/i, /googletagmanager\.com/i, /this\.nexusWebSocket/i, /\/collectedforms\.js/i,
    // hubspot
    /\/li.lms-analytics/i,
    // 3rd party analytics
    /hotjar/i, /\/frame-/i, /google-analytics\.com\/analytics\.js/i, /translate\.googleapis\.com/i, /translate\.google\.com/i, /msDiscoverChatAvailable/i, /\/Applications\//,
    // Applications on macOS - can be Safari extensions.
    /\/persona\.js/,
    // persona.js library
    /js\.stripe\.com/,
    // stripe library
    /@stripe\/stripe-js/,
    // stripe library
    /intercom/,
    // Intercom
    /maps\.googleapis\.com/,
    // Google Maps sdk
    /\/parchment\//,
    // parchment 3rd party library (used by Quill)
    /\/quill\.js/,
    // Quill - our rich-text editor
    /hs-analytics/,
    // Hubspot analytics
    /material-ui\.js$/,
    // Material UI
    /zapier\.com/ // Zapier
    ],
    ignoreErrors: ["Failed to execute 'sendBeacon' on 'Navigator'", /Network Error/i, /NetworkError/i, /__gCrWeb/, /\[Parchment\]/i, /^AxiosError:/, 'ResizeObserver loop limit exceeded', "Failed to execute 'removeChild' on 'Node'", "Can't find variable: gmo", "Cannot read properties of undefined (reading 'domInteractive')", "Can't find variable: lastScrollEventTimestamp"],
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click' || breadcrumb.category === 'ui.input') {
        var _hint$event;
        const testid = hint === null || hint === void 0 || (_hint$event = hint.event) === null || _hint$event === void 0 || (_hint$event = _hint$event.target) === null || _hint$event === void 0 || (_hint$event = _hint$event.dataset) === null || _hint$event === void 0 ? void 0 : _hint$event.testid;
        if (testid) {
          breadcrumb.message = "data-testid=".concat(testid);
        }
      }
      return breadcrumb;
    }
  });
  if (window._sessionId) {
    Sentry.setTag('sessionId', window._sessionId);
  }
}